import { Injectable } from "@angular/core";
import { DSRESTClient } from "../shared/communication-objects/restclient.service";
import { api, part } from "../shared/communication-objects/api-path";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { LogService } from "./log.service";

@Injectable()
export class UsageService {
  getTankUsageAnomalies(params: any) {
    return this.restClient
      .getDirect<any>(
        api`${this.apiUrl}/getTankUsageAnomalies/${part(params?.tankId)}?frmDt=${part(params?.fromDate)}&toDt=${part(params?.toDate)}&orgId=${part(params?.orgId)}&incCO=${part(params?.includeChildOrganizations)}`
      )
      .pipe(
        tap((results) => {
          this.logger.log("getTankUsageAnomalies", params, results);
        })
      );
  }

  private readonly apiUrl = api`Usage`;

  constructor(private restClient: DSRESTClient, private logger: LogService) {}

  get(params: any): Observable<any> {
    return this.restClient.post(this.apiUrl, params);
  }

  getOrgDailyUsage(params: any): Observable<any> {
    return this.restClient
      .getDirect<any>(
        api`${this.apiUrl}/getOrgDailyUsage/${part(params?.orgId)}?frmDt=${part(params?.fromDate)}&toDt=${part(params?.toDate)}&incCO=${part(params?.includeChildOrganizations)}`
      )
      .pipe(
        tap((results) => {
          this.logger.log("OrgDailyUsageChart", params, results);
        })
      );
  }

  getTankDailyUsageChartDataAsync(tankId: number): Observable<any> {
    const apiResponse = this.restClient.getDirect<any>(
      api`${this.apiUrl}/getTankDailyUsageChartDataAsync/${tankId}`
    );
    return apiResponse.pipe(
      tap((response) =>
        this.logger.log('getTankDailyUsageChartDataAsync Response', response)
      )
    );
  }
}
